import HTTP from '../http';
import token from './token';

export default {
  namespaced: true,
  state: {
    token: null,
    loginEmail: null,
    loginPassword: null,
    loginError: null,
    loggedIn: false,
  },
  actions: {
    logout({ commit }) {
      commit('setToken', null);
    },
    login({ commit, state }) {
      commit('setLoginError', null);
      return HTTP().post('/auth/login', {
        email: state.loginEmail,
        password: state.loginPassword,
      })
        .then(({ data }) => {
          token.state.token = data.token;
          commit('setLoggedIn', { loggedInValue: true, tokenToSave: data.token });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            commit('setLoginError', 'Usuário e/ou senha incorretos');
          } else {
            commit('setLoginError', 'Ocorreu um erro ao tentar logar');
          }
        });
    },
    logOut({ commit }) {
      commit('setLoggedIn', { loggedInValue: false, tokenToSave: null });
      token.state.token = null;
    },
    applySavedToken({ state }) {
      token.state.token = state.token;
    },
  },
  getters: {

  },
  mutations: {
    setLoggedIn(state, { loggedInValue, tokenToSave }) {
      state.loggedIn = loggedInValue;
      state.token = tokenToSave;
    },
    setLoginError(state, error) {
      state.loginError = error;
    },
    setLoginEmail(state, email) {
      state.loginEmail = email;
    },
    setLoginPassword(state, password) {
      state.loginPassword = password;
    },
  },
};
